import { render, staticRenderFns } from "./TemTwo.vue?vue&type=template&id=1af8bedc&scoped=true&"
import script from "./TemTwo.vue?vue&type=script&lang=js&"
export * from "./TemTwo.vue?vue&type=script&lang=js&"
import style0 from "./TemTwo.vue?vue&type=style&index=0&id=1af8bedc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8bedc",
  null
  
)

export default component.exports